module.exports = __webpack_public_path__ + "img/wh_animated_logo.0975de26.svg";